import {
  AfterViewChecked,
  AfterViewInit, Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild } from '@angular/core';

import { applyFrameToElement, MANIP_FRAME_IDLE } from '../../../../utils/utils';
import { ScorableData } from '../kh-manip-scorable/IScorable';

@Component({
  selector: 'clickable-region',
  templateUrl: 'kh-manip-scorable-region.component.html',
  styleUrls: ['kh-manip-scorable-region.component.less'],
  standalone: false
})
export class KhManipulativeClickableRegionComponent implements AfterViewChecked, OnInit, AfterViewInit {
  public onChangeCallback: undefined | ((data: ScorableData) => void); // callback
  @Input() public key = '';
  @Input() public index!: number;
  @Input() public value!: ScorableData;
  @Input() public shape = 'rectagle';
  @Input() public background = '';
  @Input('has-outline') public hasOutline = 'false';
  @Input() public frame = '0 0 0 0';
  @Input('clicked-image') public clickedImage?: string;
  @Input('ignore-in-score') public ignoreInScore = false;
  @Input('default-value') public defaultValue?: string;
  @Input() selected = false;
  @Input('countname') public countVarName = '';

  @ViewChild('region', { static: true })
  public regionElement!: ElementRef<HTMLDivElement>;

  @ViewChild('imageElement', { static: true })
  public imageElement!: ElementRef<HTMLImageElement>;

  public clickCallback: undefined | ((data: ScorableData, element: KhManipulativeClickableRegionComponent) => void); // callback
  public borderRadius = '';
  public border = '';
  private enabled = true;

  public constructor(private hostElement: ElementRef) {}

  public ngOnInit() {
    this.setImageVisibility();

    this.borderRadius = this.shape?.toLocaleLowerCase() === 'oval' ? '50%' : '';
    this.border = this.hasOutline === 'true' ? MANIP_FRAME_IDLE : 'none';
  }

  public ngAfterViewInit() {
    applyFrameToElement(this.regionElement.nativeElement, this.frame);
  }

  public setClickEnabled(val: boolean) {
    this.enabled = val;

    if (!val) {
      this.regionElement.nativeElement.style.cursor = 'none';
    }
  }

  public setImageVisibility() {
    if (this.selected) {
      this.imageElement.nativeElement.style.visibility = 'visible';
    } else {
      this.imageElement.nativeElement.style.visibility = 'hidden';
    }
  }

  public ngAfterViewChecked(): void {
    this.setImageVisibility();
    this.regionElement.nativeElement.style.cursor = this.enabled ? 'pointer' : 'default';
  }

  public onChangeValue(val: string): void {
    if (this.enabled) {
      this.selected = !this.selected;
      this.setImageVisibility();

      if (this.clickCallback) {
        this.clickCallback(this.getRegionScorableData(), this);
      }

      // if this has been selected, we want to move it to the lowest part of it's sibling stack so that it appears on top
      // Some manipulatives when clicked will intentionally overlay the others and block them, this preserves that behavior
      if (this.selected) {
        const parent = this.hostElement.nativeElement.parentElement;
        if (parent) {
          parent.appendChild(this.hostElement.nativeElement);
        }
      }
    }
  }

  public getRegionScorableData() {
    const selected = this.selected ? '1' : '0';

    const data: ScorableData = {
      answer: { [this.key]: selected },
      state: { [this.key]: selected }
    };

    return data;
  }

  public getUrl(): string {
    return this.clickedImage?.replace(/^'|'$/g, '') || '';
  }
}
